import { Fragment, FunctionalComponent, h } from 'preact';
import { useContext } from 'preact/hooks';
import { IntlContext } from 'preact-i18n';
import { WeekdayKey } from '../../common/calendar';
import { dateI18n, DateI18n, IntlContextWithDictionary } from '../types';
import { DateFormat, dateFormat, marked } from './dateFormatUtils';

export interface DateTextProps {
  value: string;
  format: DateFormat;
}

export const DateText: FunctionalComponent<DateTextProps> = ({ value, format }: DateTextProps): h.JSX.Element => {
  const context: IntlContextWithDictionary = useContext(IntlContext);
  const dateText = dateFormat(value, format, context as IntlContextWithDictionary);
  return <Fragment>{context?.intl?.mark ? marked(format, dateText) : dateText}</Fragment>;
};

// == WEEKDAY FORMAT ===========================================================

export enum WeekdayFormat {
  FULL = 'full',
  SHORT = 'short',
}

export interface WeekdayTextProps {
  value: WeekdayKey;
  format: WeekdayFormat;
}

export const WeekdayText: FunctionalComponent<WeekdayTextProps> = ({
  value,
  format,
}: WeekdayTextProps): h.JSX.Element => {
  const context: IntlContextWithDictionary = useContext(IntlContext);
  const i18n: DateI18n = dateI18n(context as IntlContextWithDictionary);
  const localizedWeekDay = format === WeekdayFormat.SHORT ? i18n.weekdaysShort[value] : i18n.weekdays[value];
  return <Fragment>{context?.intl?.mark ? marked(format, localizedWeekDay) : localizedWeekDay}</Fragment>;
};
